export enum TOOLBAR {
  REDO = 're_do',
  UNDO = 'un_do',
  ROTATE_CLOCKWISE = 'rotate_clockwise',
  ROTATE_COUNTERCLOCKWISE = 'rotate_counterclockwise',
  REMOVE = 'remove',
  DUPLICATE = 'duplicate',
  ZOOM_IN = 'zoom_in',
  ZOOM_OUT = 'zoom_out',
  ZOOM_TO_FIT = 'zoom_to_fit',
}

export const mainButtons = [
  TOOLBAR.UNDO,
  TOOLBAR.REDO,
  TOOLBAR.ROTATE_CLOCKWISE,
  TOOLBAR.ROTATE_COUNTERCLOCKWISE,
  TOOLBAR.DUPLICATE,
  TOOLBAR.REMOVE,
];

export const zoomButtons = [
  TOOLBAR.ZOOM_IN,
  TOOLBAR.ZOOM_OUT,
  TOOLBAR.ZOOM_TO_FIT,
];

export type TOOLBAR_ENABLING =
  | TOOLBAR.REDO
  | TOOLBAR.UNDO
  | TOOLBAR.REMOVE
  | TOOLBAR.DUPLICATE;
